import React, { useState } from 'react';
import Routes from 'routes';

import BasePriceOverlay from './BasePriceOverlay';
import { customFetch } from 'utils/fetch';

export interface BasePriceButtonProps extends React.HTMLAttributes<HTMLButtonElement> {
  lot_id: string;
  warehouse_name: string;
  reception_date: string;
  currency_symbol: string;
}

interface BasePriceResponse {
  success: boolean;
  errors?: string[];
}

// PLA-1086: abre la captura del precio base de la fecha de recibimiento del lote. Sólo se monta
// para usuarios con permiso de actualización de la variable de precio (lo decide la policy en el
// servidor, ver AcceptPricePolicy#update_base_price?).
const BasePriceButton: React.FC<BasePriceButtonProps> = ({
  lot_id,
  warehouse_name,
  reception_date,
  currency_symbol,
}) => {
  const [showOverlay, setShowOverlay] = useState(false);
  const [errors, setErrors] = useState<string[]>([]);
  const [saving, setSaving] = useState(false);

  const handleOnClick = () => {
    setErrors([]);
    setShowOverlay(true);
  };

  const handleOnCloseClick = () => setShowOverlay(false);

  const handleOnPrimaryClick = async (event: React.MouseEvent, base_price: string) => {
    setSaving(true);

    try {
      const response = await customFetch<BasePriceResponse>(
        Routes.api_v1_lot_base_prices_path(lot_id),
        { base_price },
        'POST'
      );

      // El precio registrado destraba todos los lotes pendientes de esa fecha, así que se recarga
      // la pantalla completa en vez de actualizar sólo esta fila.
      if (response.success) {
        window.location.reload();
        return;
      }

      setErrors(response.errors || []);
    } catch (e) {
      setErrors([I18n.translate('accept_price.index.base_price.overlay.error')]);
    }

    setSaving(false);
  };

  return (
    <>
      {showOverlay && (
        <BasePriceOverlay
          onPrimaryClick={handleOnPrimaryClick}
          onCloseClick={handleOnCloseClick}
          warehouseName={warehouse_name}
          receptionDate={reception_date}
          currencySymbol={currency_symbol}
          errors={errors}
          saving={saving}
        />
      )}

      <button
        onClick={handleOnClick}
        type='button'
        className='button button--small button--medium-blue'
        data-cy='base_price'
      >
        {I18n.translate('accept_price.index.base_price.button')}
      </button>
    </>
  );
};

export default BasePriceButton;
